import { render, staticRenderFns } from "./DesgloseProyecto.vue?vue&type=template&id=ac9d9492&"
import script from "./DesgloseProyecto.vue?vue&type=script&lang=js&"
export * from "./DesgloseProyecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports